import axios, { AxiosError } from 'axios';
import { getInitData } from './telegram';

const baseURL = (import.meta.env.VITE_API_BASE_URL as string | undefined) || '/api';

export const api = axios.create({ baseURL, timeout: 30000 });

api.interceptors.request.use(config => {
    const initData = getInitData();
    if (initData) {
        config.headers.set('Authorization', `tma ${initData}`);
    } else if (import.meta.env.DEV) {
        // Development outside Telegram: the API must run with MINIAPP_DEV_BYPASS=1.
        const devId = (import.meta.env.VITE_DEV_TELEGRAM_ID as string | undefined) || '';
        if (devId) config.headers.set('x-dev-telegram-id', devId);
    }
    return config;
});

/** `{ error: code, ...vars }` from the API, or a network / unknown error. */
export interface ApiErrorShape {
    error: string;
    status?: number;
    [key: string]: unknown;
}

export function apiError(err: unknown): ApiErrorShape {
    if (err && typeof err === 'object' && 'isAxiosError' in err) {
        const ax = err as AxiosError<ApiErrorShape>;
        if (ax.response?.data && typeof ax.response.data === 'object' && ax.response.data.error) return { ...ax.response.data, status: ax.response.status };
        if (ax.code === 'ECONNABORTED') return { error: 'timeout' };
        return { error: 'network_error', status: ax.response?.status };
    }
    return { error: 'unknown_error' };
}
